import React from 'react';
import { connect } from 'react-redux';
import fetch from '../hooks/fetch';
import CohortPanelContainer, { mapDispatchToProps, mapStateToProps } from '../components/CohortPanelContainer';
import CohortErrorMessages from '../components/CohortErrorMessages';
import CohortNoDatasetAccess from './CohortNoDatasetAccess';
import SelectCohortSourceCompact from '../components/SelectCohortSourceCompact';
import CohortInfoGridCompact from '../components/CohortInfoGridCompact';

const CohortPanelNarrow = ({
  allowCohortVisualisations,
  canRead,
  category,
  chartType,
  code,
  description,
  exists,
  isDirty,
  isNew,
  name,
  onChange,
  queryAccess,
  readErrors,
  readStatus,
  validationErrors,
  saveErrors,
  selectChart,
  selectSource,
  updateProperties,
  url,
}) => {
  fetch.useFetchCohort({ category, code, isNew }, readStatus);
  return (
    <CohortPanelContainer
      canRead={canRead}
      description={description}
      exists={exists}
      isDirty={isDirty}
      isNew={isNew}
      name={name}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={readStatus}
      validationErrors={validationErrors}
      saveErrors={saveErrors}
      url={url}
    >
      <div className="aridhia-cohort-panel-narrow overflow-x-hidden">
        <CohortErrorMessages
          code={code}
          category={category}
          entities={['server', 'cohort', 'query', 'clause', 'filter']}
          readErrors={readErrors}
          validationErrors={validationErrors}
          saveErrors={saveErrors}
          updateProperties={updateProperties}
        />
        {selectSource && (<SelectCohortSourceCompact code={code} category={category} />)}
        {!queryAccess && (<CohortNoDatasetAccess code={code} category={category} />)}
        {!selectSource && (
        <CohortInfoGridCompact
          category={category}
          code={code}
          allowCohortVisualisations={allowCohortVisualisations}
          chartType={chartType}
          queryAccess={queryAccess}
          selectChart={selectChart}
          isNew={isNew}
        />
        )}
      </div>
    </CohortPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortPanelNarrow);
